export default __webpack_public_path__ + "static/media/dropdown_settings.4200a004.svg";